<div class="move-submission-modal">
    @if (isSubmitting()) {
        <div class="loading-overlay">
            <span class="loading"></span>
        </div>
    }
    <h4>Move Submission{{ data.submissionIds.length > 1 ? "s" : "" }}</h4>
    <button
        type="button"
        class="close-btn"
        [disabled]="isSubmitting()"
        (click)="close()"
        aria-label="Close"
    >
        <span class="icon-close"></span>
    </button>

    @if (data.interactiveOptions.length > 0) {
        <mat-form-field appearance="outline">
            <mat-select
                [formControl]="interactiveControl"
                placeholder="&mdash; Choose Interactive &mdash;"
            >
                @for (option of data.interactiveOptions; track option.id) {
                    <mat-option [value]="option.id">
                        {{ option.name }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>

        <div class="actions">
            <tools-button
                [variant]="ButtonVariant.OUTLINE"
                [isDisabled]="isSubmitting()"
                (onClick)="close()"
            >
                Cancel
            </tools-button>
            <tools-button
                [isDisabled]="interactiveControl.invalid || isSubmitting()"
                (onClick)="moveSubmissions()"
            >
                Move Submission{{ data.submissionIds.length > 1 ? "s" : "" }}
            </tools-button>
        </div>
    } @else {
        <p class="no-options-message">
            There are no valid interactive
            {{
                data.submissionIds.length > 1
                    ? "these submissions"
                    : "this submission"
            }}
            can be moved into.
        </p>
    }
</div>
